import { useQuery, useQueryClient } from 'react-query';
import { gateway } from '../utils/api';

export const SURVEY_STATUS_KEY = 'survey-response-status';
const SURVEY_STATUS_STALE_MS = 30000;
const COMPLETED_STATUS = 'COMPLETED';

export function fetchSurveyResponseStatus(formCode) {
  return gateway.get('/feedback/response/status', { params: { formCode } });
}

export function isSurveyCompleted(status) {
  return !!status && status.status === COMPLETED_STATUS;
}

export function useSurveyResponseStatus(formCode) {
  return useQuery(
    [SURVEY_STATUS_KEY, formCode],
    () => fetchSurveyResponseStatus(formCode),
    { enabled: !!formCode, staleTime: SURVEY_STATUS_STALE_MS, refetchOnWindowFocus: false }
  );
}

export function useInvalidateSurveyStatus() {
  const queryClient = useQueryClient();
  return formCode => queryClient.invalidateQueries([SURVEY_STATUS_KEY, formCode]);
}
